module.exports = __webpack_public_path__ + "img/wx_z_2.0a6f7250.png";